module.exports = __webpack_public_path__ + "img/ring_0_0_0_1.2febf542.png";